module.exports = __webpack_public_path__ + "static/img/m_role.ccc3a5c.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/yzzzbq/m_role.png
// module id = 4ESz
// module chunks = 7